import StakeholderBenefits from './StakeholderBenefits';

export default StakeholderBenefits;
